import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";
import {
  TOOLBAR_BUTTON_LABEL_CLASS,
  toolbarIconOnlyButtonSx,
} from "common/Components/DataTable/tableToolbarButton.styles";

const uiFont = appThemeFonts.family.ui;

const BulkEditToolbarButton = styled(Button)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
  height: 34,
  minHeight: 34,
  padding: "0 14px",
  backgroundColor: appThemeColors.background.paper,
  border: `1px solid ${appThemeColors.border.strong}`,
  borderRadius: appThemeRadius.pill,
  color: appThemeColors.text.primary,
  fontSize: "12.5px",
  fontWeight: 500,
  fontFamily: uiFont,
  textTransform: "none",
  whiteSpace: "nowrap",
  boxShadow: "none",
  lineHeight: 1.2,
  "& .MuiButton-startIcon": {
    marginRight: 0,
    marginLeft: 0,
    "& > *:nth-of-type(1)": {
      fontSize: 14,
    },
  },
  "&:hover": {
    backgroundColor: appThemeColors.background.kbd,
    borderColor: appThemeColors.text.lightBlue,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: appThemeColors.background.paper,
    border: `1px solid ${appThemeColors.border.default} !important`,
    color: `${appThemeColors.text.faint} !important`,
    WebkitTextFillColor: appThemeColors.text.faint,
    opacity: 0.55,
  },
  [theme.breakpoints.down("sm")]: {
    flex: "1 1 auto",
  },
  ...toolbarIconOnlyButtonSx,
}));

export default function TableBulkEditButton({
  visible,
  disabled,
  label,
  title,
  onClick,
}) {
  if (!visible) {
    return null;
  }

  return (
    <Tooltip title={title || ""} disableHoverListener={!title}>
      <span>
        <BulkEditToolbarButton
          variant="outlined"
          size="small"
          disabled={disabled}
          onClick={onClick}
          startIcon={<EditOutlinedIcon aria-hidden />}
        >
          <span className={TOOLBAR_BUTTON_LABEL_CLASS}>{label}</span>
        </BulkEditToolbarButton>
      </span>
    </Tooltip>
  );
}

TableBulkEditButton.propTypes = {
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

TableBulkEditButton.defaultProps = {
  visible: true,
  disabled: false,
  title: undefined,
};
